import React from "react";

const SvgCheckmark = props => <svg fill="none" viewBox="0 0 16 16" {...props}><path fill="#603276" fillRule="evenodd" d="M6.315 11.86L3.133 8.44a.507.507 0 0 1 0-.684l.643-.683a.436.436 0 0 1 .642 0l2.22 2.392 4.943-5.325a.435.435 0 0 1 .644 0l.643.684a.504.504 0 0 1 0 .682l-5.91 6.35a.433.433 0 0 1-.642 0z" clipRule="evenodd" /></svg>;

export default SvgCheckmark;